import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  return (
    <>
      <div className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <Link to="/">
              <img
                src={"/assets/img/logo.png"}
                className="img-fluid logo"
                alt="1"
              />
            </Link>
            <Link to="/">
              <img
                src="/assets/img/logo.png"
                className="img-fluid logo-small"
                alt="2"
              />
            </Link>
          </div>
        </div>
        <div className="sidebar-inner">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              <li
                className={
                  location.pathname.includes("/admin/dashboard") ? "active" : ""
                }
              >
                <Link to="/admin/dashboard">
                  <i className="fe fe-home"></i> <span>Dashboard</span>
                </Link>
              </li>
              <li className="menu-title">
                <span>Sales</span>
              </li>
              <li
                className={
                  location.pathname.includes("/admin/invoice") ? "active" : ""
                }
              >
                <Link to="/admin/invoice">
                  <i className="fe fe-tag"></i> <span>Sales</span>
                </Link>
              </li>

              <li
                className={
                  location.pathname.includes("/admin/payment") ? "active" : ""
                }
              >
                <Link to="/admin/payment">
                  <i className="fa fa-credit-card"></i> <span>Payment</span>
                </Link>
              </li>
              <li
                className={
                  location.pathname.includes("/admin/ledger") ? "active" : ""
                }
              >
                <Link to="/admin/ledger">
                  <i className="fa fa-file-invoice"></i> <span>Ledger</span>
                </Link>
              </li>
              <li className="menu-title">
                <span>Main</span>
              </li>
              <li
                className={
                  location.pathname.includes("admin/party") ? "active" : ""
                }
              >
                <Link to="/admin/party">
                  <i className="fe fe-users"></i> <span>Party</span>
                </Link>
              </li>

              <li
                className={
                  location.pathname.includes("/admin/product") ? "active" : ""
                }
              >
                <Link to="/admin/product">
                  <i className="fe fe-package"></i> <span>Product</span>
                </Link>
              </li>
              <li
                className={
                  location.pathname.includes("/admin/subproduct")
                    ? "active"
                    : ""
                }
              >
                <Link to="/admin/subproduct">
                  <i className="fa-solid fa-boxes-stacked"></i>
                  <span>Sub Product</span>
                </Link>
              </li>
              <li
                className={
                  location.pathname.includes("/admin/size") ? "active" : ""
                }
              >
                <Link to="/admin/size">
                  <i className="fe fe-minimize"></i> <span>Size</span>
                </Link>
              </li>
              <li
                className={
                  location.pathname.includes("/admin/series") ? "active" : ""
                }
              >
                <Link to="/admin/series">
                  <i className="fe fe-edit-3"></i> <span>Series</span>
                </Link>
              </li>
              <li
                className={
                  location.pathname.includes("/admin/posts") ? "active" : ""
                }
              >
                <Link to="/admin/posts">
                  <i className="fa-solid fa-images"></i> <span>Posts</span>
                </Link>
              </li>
              <li
                className={
                  location.pathname.includes("/admin/catalogue") ? "active" : ""
                }
              >
                <Link to="/admin/catalogue">
                  <i className="fe fe-file"></i> <span>Catalogue</span>
                </Link>
              </li>
               <li
                className={
                  location.pathname.includes("/admin/notification") ? "active" : ""
                }
              >
                <Link to="/admin/notification">
                  <i class="fa-solid fa-bell"></i> <span>Notification</span>
                </Link>
              </li>
              <li className="menu-title">
                <span>Location</span>
              </li>

              <li
                className={
                  location.pathname.includes("/admin/country") ? "active" : ""
                }
              >
                <Link to="/admin/country">
                  <i className="fa fa-globe"></i> <span>Country</span>
                </Link>
              </li>
              <li
                className={
                  location.pathname.includes("/admin/state") ? "active" : ""
                }
              >
                <Link to="/admin/state">
                  <i className="fa fa-location-arrow"></i> <span>State</span>
                </Link>
              </li>
              <li
                className={
                  location.pathname.includes("/admin/city") ? "active" : ""
                }
              >
                <Link to="/admin/city">
                  <i className="fa fa-thumb-tack"></i> <span>City</span>
                </Link>
              </li>
              <li
                className={
                  location.pathname.includes("/admin/profile") ? "active" : ""
                }
              >
                <Link to="/admin/profile">
                  <i className="fe fe-user"></i> <span>Profile</span>
                </Link>
              </li>
              {/* <li className={`submenu ${subMenuOpen ? "open active" : ""}`}>
                <a href="#!" onClick={() => setSubMenuOpen(!subMenuOpen)}>
                  <i className="fe fe-settings"></i> <span>Settings</span>
                  <i
                    className={`fe fe-chevron-right menu-arrow ${
                      subMenuOpen ? "rotate" : ""
                    }`}
                  ></i>
                </a>
                <ul>
                  <li
                    className={
                      location.pathname.includes("/admin/profile")
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/admin/profile">
                      <i className="fe fe-user"></i> <span>Profile</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname.includes("/admin/transport")
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/admin/transport">
                      <i className="fe fe-edit"></i> <span>Transport</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname.includes("/admin/grade") ? "active" : ""
                    }
                  >
                    <Link to="/admin/grade">
                      <i className="fe fe-package"></i> <span>Grade</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname.includes("/admin/banks") ? "active" : ""
                    }
                  >
                    <Link to="/admin/banks">
                      <i className="fe fe-codepen"></i> <span>Banks</span>
                    </Link>
                  </li>
                </ul>
              </li> */}
              {/* <li className={ (location.pathname.includes('/admin/profile')) ? 'active': '' }>
                              <Link to="/admin/profile"><i className="fe fe-settings"></i> <span>Settings</span></Link>
                   </li> */}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
